import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import NotificationModel from 'app/stores/notifications/NotificationModel';

import { Flex, Spinner, Suspense } from 'core/components';
import NotFound from 'app/views/NotFound';
import Page from 'app/components/page/Page';

import NotificationDetails from 'app/views/settings/notifications/NotificationDetails';
import storeLoader from 'app/stores/storeLoader';
import { NOTIFICATION_BROADCAST_CHANNEL_ID } from '@kentik/ui-shared/notifications/constants';

@storeLoader('$notifications.collection', '$notifications.supportedChannels')
@inject('$notifications')
@observer
export default class NotificationDetailPage extends Component {
  state = {
    error: false,
    loading: true,
    isCreate: false,
    notificationModel: null
  };

  get notificationId() {
    const { match } = this.props;
    return match.params.id;
  }

  get requestId() {
    const { location } = this.props;
    const params = new URLSearchParams(location && location.search ? location.search : '');

    return params.get('requestId');
  }

  componentDidMount() {
    this.loadNotification();
  }

  postToBroadcastChannel = (message) => {
    try {
      const bc = new BroadcastChannel(NOTIFICATION_BROADCAST_CHANNEL_ID);
      bc.postMessage(message);
      bc.close();
    } catch (e) {
      // do nothing
    }
  };

  handleIntegratedClose = (model) => {
    this.postToBroadcastChannel({
      type: model && model.id ? 'notification-created' : 'notification-cancelled',
      requestId: this.requestId,
      channelId: model && model.id
    });

    try {
      window.close();
    } catch (e) {
      // well, we tried. they can close the window themselves
    }
  };

  loadNotification() {
    const { $notifications } = this.props;
    const { collection } = $notifications;

    if (this.notificationId === 'new') {
      this.setState({
        notificationModel: new NotificationModel(),
        isCreate: true,
        loading: false
      });
      return;
    }

    const maybeModel = collection.modelById[this.notificationId];

    if (maybeModel) {
      this.setState({ notificationModel: maybeModel, loading: false });

      return;
    }

    const notificationModel = new NotificationModel();
    notificationModel
      .set({ channelID: this.notificationId })
      .fetch()
      .finally(() => {
        this.setState({ notificationModel, loading: false });
      });
  }

  get title() {
    const { notificationModel, isCreate, loading } = this.state;
    if (loading) {
      return 'Loading...';
    }

    if (isCreate) {
      return 'Create New Notification Channel';
    }

    return `Notification Details: ${notificationModel.get('name') || ''}`;
  }

  get parentLinks() {
    return [{ link: '/v4/settings/notifications', label: 'Notification Channels' }];
  }

  render() {
    const { notificationModel, loading, error, isCreate } = this.state;
    const { id } = notificationModel || {};
    const isLoading = loading || notificationModel?.requestStatus === 'fetching';

    // if there's an error or loading
    if (error || notificationModel?.error || (!isCreate && !isLoading && !id)) {
      return (
        <NotFound
          parentLinks={this.parentLinks}
          hideSubnav={false}
          title="Notification Channel Not Found"
          text={`Notification Channel ${this.notificationId} was not found.`}
        />
      );
    }

    return (
      <Page pt={0} pb={0} parentLinks={this.parentLinks} title={this.title} scrolls showExport>
        <Suspense loading={isLoading} fallback={<Spinner intent="primary" m="auto" />}>
          {!notificationModel?.error && !isLoading && (
            <Flex flex="1">
              <NotificationDetails
                onClose={this.requestId ? this.handleIntegratedClose : undefined}
                isCreate={isCreate}
                model={notificationModel}
              />
            </Flex>
          )}
        </Suspense>
      </Page>
    );
  }
}
